import secureLocalStorage from "react-secure-storage";
import { GridCell } from "@progress/kendo-react-grid";
import { TextArea } from "@progress/kendo-react-inputs";
import React from "react";
import "../../Styles/RiskDiscription.scss";

export default class RiskTitleCell extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      temp: this.props.dataItem.riskTitle,
      risktitleclass:"k-grid-content-sticky k-grid-content-sticky-temp  inlineEditField"
    };
    
  }
  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("riskTitleId")){
        document.getElementById("riskTitleId").focus();
    }

    // this.reportWindowSize();
  };

  
  reportWindowSize = () => {
    if(window.innerWidth > 768){
      this.setState({risktitleclass:"k-grid-content-sticky"})
    }
    else{
      this.setState({risktitleclass:""})
    }
   }

  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
   
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    this.props.handleCellAddValue(this.state.temp);
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        riskTitle: this.state.temp,
      };
      if (this.state.temp != this.props.dataItem.riskTitle) {
        this.props.updateDropdownValue(updateData);
      }
    }
  };
  handleChangeForAdd = (e) => {
    this.props.handleCellAddValue(e.value);
  };
  handleBlurForAdd=(e)=>{
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  }
  handleEditCell = () => {
    // if (this.props.dataItem.riskRegisterId) {
    this.props.onEditCell(this.props.dataItem, this.props.field);
    // }
  };
  render() {
    
    // window.addEventListener('resize', this.reportWindowSize);
    // window.addEventListener('load', this.reportWindowSize);

    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;

    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
        
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td className={this.state.risktitleclass}
        //  style={{ left:'300px', right: "0px" }}
         >
          {this.props.riskAddOrEdit == true ? (
            <TextArea
              defaultValue={dataValue}
              onChange={(e) => this.handleChangeForAdd(e)}
              onBlur={(e) =>this.handleBlurForAdd(e)}
              id="riskTitleId"
            />
          ) : (
            <TextArea
              defaultValue={dataValue}
              onChange={(e) => this.handleChange(e)}
              onBlur={this.handleBlur}
              id="riskTitleId"
            />
          )}
        </td>
      );
    } else { 
      if(loginUserId===ownerId){
        if(this.props.dataItem.role == "Standard User" ||
        this.props.dataItem.role == "View Only"){
          return(
            <td   title={dataValue} onClick={this.handleEditCell} className={this.state.risktitleclass}
            
            style={{ left:this.props.pageName === 'home' ? '300px':'142px', right: "0px" }}
            >
            <p>{dataValue}</p>
          </td>)
        }
        else{
          return(
            <td   title={dataValue} onClick={this.handleEditCell} className={this.state.risktitleclass}
            
            style={{ left:this.props.pageName === 'home' ? '300px':'287px', right: "0px" }}
            >
            <p>{dataValue}</p>
          </td>)
        }
        
      }else{
      return this.props.dataItem.role == "Standard User" ||
      this.props.dataItem.role == "View Only" ? (
        <td  title={dataValue}  className={this.state.risktitleclass}
        style={{ left: this.props.pageName === 'home' ? '300px':'142px', right: "0px" }}
        >
          <p>{dataValue}</p>
        </td>
      ) : (
        <td   title={dataValue} onClick={this.handleEditCell} className={this.state.risktitleclass}
        style={{ left:this.props.pageName === 'home' ? '300px':'287px', right: "0px" }}
        >
          <p>{dataValue}</p>
        </td>
      );
      }
    }
  }
}
